const countries = function(key) {
  const countryKey = typeof key === 'string' ? key.toLowerCase() : 'unknown'
  return ({
      br: {
        country: 'Brazil',
        stronghold: 'Americas'
      },
      ca: {
        country: 'Canada',
        stronghold: 'Americas'
      },
      ca_fr: {
        country: 'Canada',
        stronghold: 'Americas'
      },
      ca_en: {
        country: 'Canada',
        stronghold: 'Americas'
      },
      mx: {
        country: 'Mexico',
        stronghold: 'Americas'
      },
      us: {
        country: 'USA',
        stronghold: 'Americas'
      },
      au: {
        country: 'Australia',
        stronghold: 'APAC'
      },
      hk: {
        country: 'Hong Kong',
        stronghold: 'APAC'
      },
      hk_en: {
        country: 'Hong Kong',
        stronghold: 'APAC'
      },
      id: {
        country: 'Indonesia',
        stronghold: 'APAC'
      },
      jp: {
        country: 'Japan',
        stronghold: 'APAC'
      },
      kr: {
        country: 'Korea',
        stronghold: 'APAC'
      },
      my: {
        country: 'Malaysia',
        stronghold: 'APAC'
      },
      nz: {
        country: 'New Zealand',
        stronghold: 'APAC'
      },
      ph: {
        country: 'Philippines',
        stronghold: 'APAC'
      },
      sg: {
        country: 'Singapore',
        stronghold: 'APAC'
      },
      th: {
        country: 'Thailand',
        stronghold: 'APAC'
      },
      tw: {
        country: 'Taiwan',
        stronghold: 'APAC'
      },
      vn: {
        country: 'Vietnam',
        stronghold: 'APAC'
      },
      kz: {
        country: 'Kazakhstan',
        stronghold: 'APAC'
      },
      cn: {
        country: 'China',
        stronghold: 'China'
      },
      at: {
        country: 'Austria',
        stronghold: 'Europe'
      },
      ch: {
        country: 'Switzerland',
        stronghold: 'Europe'
      },
      de: {
        country: 'Germany',
        stronghold: 'Europe'
      },
      dk: {
        country: 'Denmark',
        stronghold: 'Europe'
      },
      es: {
        country: 'Spain',
        stronghold: 'Europe'
      },
      eu: {
        country: 'Europe',
        stronghold: 'Europe'
      },
      fi: {
        country: 'Finland',
        stronghold: 'Europe'
      },
      fr: {
        country: 'France',
        stronghold: 'Europe'
      },
      it: {
        country: 'Italy',
        stronghold: 'Europe'
      },
      nl: {
        country: 'Netherlands',
        stronghold: 'Europe'
      },
      no: {
        country: 'Norway',
        stronghold: 'Europe'
      },
      pl: {
        country: 'Poland',
        stronghold: 'Europe'
      },
      pt: {
        country: 'Portugal',
        stronghold: 'Europe'
      },
      ru: {
        country: 'Russia',
        stronghold: 'Europe'
      },
      hr: {
        country: 'Croatia',
        stronghold: 'Europe'
      },
      cz: {
        country: 'Czech',
        stronghold: 'Europe'
      },
      se: {
        country: 'Sweden',
        stronghold: 'Europe'
      },
      uk: {
        country: 'United Kingdom',
        stronghold: 'Europe'
      },
      ro: {
        country: 'Romania',
        stronghold: 'Europe'
      },
      ro: {
        country: 'Romania',
        stronghold: 'Europe'
      },
      sk: {
        country: 'Slovakia',
        stronghold: 'Europe'
      },
      hu: {
        country: 'Hungary',
        stronghold: 'Europe'
      },
      global: {
        country: 'Global',
        stronghold: 'Global'
      },
      ae: {
        country: 'Arabic Emirates',
        stronghold: 'IMEA'
      },
      ae_sa: {
        country: 'Arabic Emirates',
        stronghold: 'IMEA'
      },
      ae_en: {
        country: 'Arabic Emirates',
        stronghold: 'IMEA'
      },
      eg: {
        country: 'Egypt',
        stronghold: 'IMEA'
      },
      eg_en: {
        country: 'Egypt',
        stronghold: 'IMEA'
      },
      in: {
        country: 'India',
        stronghold: 'IMEA'
      },
      il: {
        country: 'Israel',
        stronghold: 'IMEA'
      },
      me: {
        country: 'Middle East & Africa',
        stronghold: 'IMEA'
      },
      mea: {
        country: 'Middle East & Africa',
        stronghold: 'IMEA'
      },
      sa: {
        country: 'Saudi arabia',
        stronghold: 'IMEA'
      },
      sa_ar: {
        country: 'Saudi arabia',
        stronghold: 'IMEA'
      },
      tr: {
        country: 'Turkiska',
        stronghold: 'IMEA'
      },
      za: {
        country: 'South Africa',
        stronghold: 'IMEA'
      },

    }[countryKey] || {
      stronghold: 'unknown',
      name: 'unknown'
    })
}

export default countries



// WEBPACK FOOTER //
// ./src/utils/countries.js